import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
} from '@mui/material';
import { ConversationChannelTypeExtended } from '@provision/chat-utils';
import { useCallback } from 'react';
import { DynamicIcon } from 'src/components';
import { getConversationIcon } from 'src/pages/Conversations/constants';

const MessageTypeControl = styled(FormControl, {
  name: 'MessageTypeControl',
})(() => ({
  alignSelf: 'flex-start',
  alignItems: 'center',
  '&:focus': {
    backgroundColor: 'transparent',
  },
  '& .MuiInputBase-input': {
    display: 'flex',
    alignItems: 'center',
  },
}));

interface MessageTypeOption {
  label: string;
  value: ConversationChannelTypeExtended;
}

export interface MessageTypeSelectorProps {
  selectedValue: string;
  onMessageTypeChange: (value: ConversationChannelTypeExtended) => void;
  options: MessageTypeOption[];
}

const MessageTypeSelector = ({
  selectedValue,
  options,
  onMessageTypeChange,
}: MessageTypeSelectorProps) => {
  const handleOnChange = useCallback(
    (event: SelectChangeEvent) => {
      onMessageTypeChange(event.target.value as ConversationChannelTypeExtended);
    },
    [onMessageTypeChange],
  );

  return (
    <MessageTypeControl size="small" variant="standard">
      <Select
        value={selectedValue}
        disableUnderline
        onChange={handleOnChange}
        SelectDisplayProps={{
          style: { backgroundColor: 'transparent' },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ display: 'flex' }}>
            <Stack
              direction="row"
              alignItems="center"
              gap={1}
              sx={{
                textWrap: 'auto',
              }}
            >
              <DynamicIcon name={getConversationIcon(option.value)} />
              {option.label}
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </MessageTypeControl>
  );
};

export default MessageTypeSelector;
